// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4da86c0c","453":"0812c402","667":"94b265e7","977":"37c68e9d"}[chunkId] + ".chunk.js";
};